/**
 * Sickle contract addresses on Base mainnet
 * Hardcoded for browser compatibility (no fs/path imports)
 */
// Addresses from packages/sickle-contracts/addresses/base-mainnet.json
const addressesJson = {
    Factory: "0x71D234A3e1dfC161cc1d081E6496e76627baAc31",
    Registry: "0x2Ef5EAFA8711E2441Bd519EED5d09F8DFEf2Ecf3",
    Implementation: "0xFfF75D099baeE29F447866bC5299Cd67C04761C8",
    AerodromeRouter: "0xcF77a3Ba9A5CA399B7c97c74d54e5b1Beb874E43",
    Strategies: {
        FarmStrategy: "0xb4383a0aeee4494347df2b10e56d699d494780be",
        NftFarmStrategy: "0xd6080a387855eb2ed756d04c77e688c6d59fd2e1",
        SimpleFarmStrategy: "0xd794689e9525727f95db23566cf1ea6337dc8f8a",
        SweepStrategy: "0x99a2f52f16cfce079521016637f52c3e63f60dcc",
        AdditionalStrategies: [
            "0xb7aaa31c608c8ede366677df6e759ff4f9bc9841",
            "0xa6bb36e3a345df75449dbd191c9ee5a13b17c436",
            "0x90cff0ea580c8ec12f7ef38b2cad0fd590ab120b",
            "0xfe653b9f946320232e3aae53d5466fd08362cfbc",
            "0x43be0d954142e3f6a935532a2689df5c417a29a4",
            "0xd4c72eea15315ea2f83f5553198f18730ce6ab07",
            "0x9cf9a181a0acfc2b644410b8215e1972317ccdc1",
            "0xb156de7c7bee0c9603415d6b8b5ef983a333ab3d"
        ]
    },
    Notes: {
        Source: "Found via BaseScan exploration of SickleFactory constructor arguments and SickleRegistry TargetStatusChanged events",
        Factory: "SickleFactory contract - deploys Sickle wallets per user",
        Registry: "SickleRegistry contract - manages whitelisted strategies and targets",
        Implementation: "Sickle implementation contract (used by Factory for clones)",
        Strategies: "Strategy addresses identified from TargetStatusChanged events (isWhitelisted=true). Main strategy types identified from most recent whitelisting events. Additional strategies listed may include other strategy types or connector contracts.",
        Verification: "All strategy addresses were whitelisted via SickleRegistry.setWhitelistedTargets() calls. Verify strategy types by checking contract source code on BaseScan."
    }
};
export const addresses = addressesJson;
/**
 * Get contract address by name
 */
export function getAddress(name) {
    const value = addresses.Strategies[name];
    if (name === 'AdditionalStrategies') {
        return value;
    }
    return value;
}
/**
 * Get all addresses for a specific chain
 * Currently only Base mainnet is supported
 */
export function getAddresses(chainId = 8453) {
    if (chainId !== 8453) {
        throw new Error(`Chain ID ${chainId} not supported. Only Base mainnet (8453) is supported.`);
    }
    return addresses;
}
